module.exports = __webpack_public_path__ + "static/media/img3.5e34086d.jpeg";